import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { ContentItemRenderVariantProps } from "~/components/content/content-item-render/types";
import { HomepageVideoDurationOverlay } from "~/components/video/video-duration-overlay/variants/homepage";
import type { homeFocusContentItemContent$key } from "~/queries/__generated__/homeFocusContentItemContent.graphql";

import { Container, CoverImage, Headline, ImageContainer, StyledEntityLink } from "./styles";

export type Props = {
  reference: homeFocusContentItemContent$key;
} & ContentItemRenderVariantProps;

export const ContentItemHomeFocus = forwardRef<HTMLDivElement, Props>(
  ({ className, onClick, provider, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment homeFocusContentItemContent on Content {
          ...entityLink
          entityId
          ... on Video {
            duration
          }
        }
      `,
      reference_,
    );

    return (
      <StyledEntityLink reference={content} onClick={() => onClick?.(content.entityId)}>
        <Container className={className} ref={reference}>
          <ImageContainer>
            <CoverImage>
              {provider.coverImage({
                responsiveVariants: {
                  desktopUp: "size540x360",
                  mobileUp: "size540x360",
                  tabletUp: "size540x360",
                },
              })}
            </CoverImage>
            {content?.duration && <HomepageVideoDurationOverlay duration={content.duration} />}
          </ImageContainer>
          <Headline>
            {provider.headline({ hideTooltip: true, preferSocialHeadline: true })}
          </Headline>
        </Container>
      </StyledEntityLink>
    );
  },
);

ContentItemHomeFocus.displayName = "ContentItemHomeFocus";
